import { graphql } from "gql.tada";

export const FootnoteFragment = graphql(`
  fragment FootnoteFragment on Footnote {
    sys {
      id
    }
    text
  }
`);
